import { calendarEntryPoint } from '@jira/spa-apps__business-calendar-new/src/calendarEntryPoint.entrypoint.tsx';
// eslint-disable-next-line jira/import/no-restricted-import
import { getProjectViewResources } from '@jira/router-resources__business-common/src/getBusinessProjectResources.tsx';
import { chromelessLayout } from '@jira/platform__layouts-chromeless-layout/src/index.tsx';
import { ThemedLazySkeleton } from '@jira/platform__project-theme-components/src/ui/ThemedLazySkeleton.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { jiraBusinessCalendarEmbedRoute } from '@jira/router-routes__business-calendar-routes/src/jiraBusinessCalendarEmbedRoute.tsx';
import { createChromelessEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import type { Route } from '@atlassian/react-resource-router';

const calendarEmbedPageEntrypoint = createChromelessEntryPoint({
	main: calendarEntryPoint,
});

export const jiraBusinessCalendarEmbedRouteEntry: Route = createEntry(
	jiraBusinessCalendarEmbedRoute,
	() => ({
		group: 'classic-business',
		ufoName: 'jwm.calendar-embed-view',

		entryPoint() {
			return calendarEmbedPageEntrypoint;
		},

		layout: chromelessLayout,
		skeleton: ThemedLazySkeleton,
		resources: getProjectViewResources(),
		supportsProjectTheme: 'full',
		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
